import { render, staticRenderFns } from "./AS_Footer.vue?vue&type=template&id=4086df2a&scoped=true&"
var script = {}
import style0 from "./AS_Footer.vue?vue&type=style&index=0&id=4086df2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4086df2a",
  null
  
)

export default component.exports